
function customizedHeader() {
  var header = document.querySelector('.header');
  if (!header) return;

  var upperRow = header.querySelector('.header__row.header__row-desktop.upper');
  var secondaryNav = upperRow ? upperRow.querySelector('[data-secondary-navigation]') : null;
  var target = header.querySelector('.header__row.header__row-desktop.lower .header__row-segment.header__row-segment-desktop.right');

  if (!secondaryNav || !target) return;

  target.insertBefore(secondaryNav, target.firstChild);

  if (upperRow) upperRow.style.display = 'none';
}

function customizedSections() {
  document.querySelectorAll('section.shopify-section').forEach(function (section) {
    var rich = section.querySelector('[data-section-type="rich-text"]');
    var video = section.querySelector('[data-section-type="video"]');

    if (rich) section.classList.add('shopify-section-rich-text');
    if (video) section.classList.add('shopify-section-video');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  customizedHeader()
  customizedSections();
});

document.addEventListener('DOMContentLoaded', () => {
  const cartLink = document.querySelector('header a[href="/cart"]');
  if (cartLink) {
    cartLink.remove();
  }
});